// extracted by mini-css-extract-plugin
module.exports = {"defaultColor":"#595959","root":"OrderStatusBadge_root__vS76s","useFade-fadeIn":"OrderStatusBadge_useFade-fadeIn__ICWYc","useFade-fadeOut":"OrderStatusBadge_useFade-fadeOut__zbG0f"};